import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Locale } from '../models/locale';

@Injectable({
  providedIn: 'root'
})
export class LocaleService {

  constructor(private http:HttpClient) { }

  async getByZipCode(code:number) :Promise<Locale[]> {
    return this.http.get<Locale[]>(`/api/locations/${code}`)
      .toPromise();
  }
}
